import { FC, HTMLProps } from 'react';
import { css, Theme } from '@emotion/react';
import { ArrowCircleDown, ArrowDown } from '@phosphor-icons/react';
import { Font } from 'client/Theme';

const dividerStyle = (theme: Theme) => css`
  position: relative;
  margin: 32px 0;
  height: 2px;
  background-color: ${theme.color.grey[60]};

  > span {
    position: absolute;
    display: flex;
    align-items: center;
    top: 50%;
    left: 50%;
    box-sizing: content-box;
    border-radius: 64px;
    border: 0.6rem solid ${theme.color.background};
    background-color: ${theme.color.background};

    transform: translate(-50%, -50%);

    > svg {
      color: ${theme.color.grey[80]};
    }
  }
`;

const plainStyle = (theme: Theme) => css`
  > span {
    border: none;
  }
`;

const pillStyle = (theme: Theme) => css`
  > span {
    gap: 0px;
    padding-right: 12px;
    background-color: ${theme.color.grey[80]};

    > svg {
      color: ${theme.color.white} !important;
      transform: scale(0.6);
    }

    > p {
      margin: 0;
      font-family: ${Font.header};
      font-size: 0.8rem;
      line-height: 23px;
      font-weight: 500;
      color: ${theme.color.white} !important;

      /**
        Chromium Only
        @see https://www.bram.us/2021/06/23/css-at-supports-rules-to-target-only-firefox-safari-chromium/#chromium
      */
      @supports (contain: paint) and (not (-moz-appearance: none)) {
        transform: translateY(1px);
      }
    }
  }
`;

export interface DividerProps extends HTMLProps<HTMLDivElement> {
  plain?: boolean;
}

export const Divider: FC<DividerProps> = ({ plain = false, children, ...other }) => (
  <div {...other} className="divider" css={[dividerStyle, plain && plainStyle, !!children && pillStyle]}>
    <span>
      {!plain && !children && <ArrowCircleDown size={24} weight="fill" />}
      {!!children && (
        <>
          <ArrowDown size={24} weight="bold" />
          <p>{children}</p>
        </>
      )}
    </span>
  </div>
);
